import api from '../../../services/api';

// The fixed-term monthly donation creation branch of handleSubmit, extracted
// VERBATIM (`if (!forever && payments && parseInt(payments) >= 1)`, inside
// `else if (donationType === 'monthly')` — reached when handleSubmit runs
// without an existing clientSecret). Not wrapped in its own try/catch at the
// call site level — see useDonationSubmit.js for how this is invoked.
export const createDonationSchedule = async ({
  elements,
  stripe,
  monthlyAmt,
  payments,
  email,
  firstName,
  lastName,
  user,
  donationFor,
  navigate,
  setError,
  setLoading,
}) => {
  // NEW APPROACH: Use PaymentMethod + Subscription Schedule
  if (!elements) {
    setError('Payment form is not ready. Please wait a moment and try again.');
    setLoading(false);
    return;
  }

  setLoading(true);
  try {
    // Step 1: Submit elements to validate the form (REQUIRED before createPaymentMethod)
    const { error: submitError } = await elements.submit();
    if (submitError) {
      setError(submitError.message || 'Please check your payment information.');
      setLoading(false);
      return;
    }

    // Step 2: Create PaymentMethod from PaymentElement (after submit)
    const { error: pmError, paymentMethod } = await stripe.createPaymentMethod({
      elements,
      params: {
        billing_details: {
          email: email,
          name: `${firstName} ${lastName}`.trim()
        }
      }
    });

    if (pmError) {
      setError(pmError.message || 'Failed to collect payment method. Please check your payment information.');
      setLoading(false);
      return;
    }

    if (!paymentMethod) {
      setError('Failed to create payment method. Please try again.');
      setLoading(false);
      return;
    }

    // Generate idempotency key (donationRequestId)
    const donationRequestId = `donation-${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;


    // Step 2: Create subscription schedule using new route
    const scheduleRequestBody = {
      email,
      name: `${firstName} ${lastName}`.trim(),
      amountUsd: monthlyAmt,
      months: parseInt(payments),
      payment_method_id: paymentMethod.id,
      donationRequestId
    };

    // Include donationFor for public users (replaces "Faith Insight Donation")
    if (!user && donationFor && donationFor.trim()) {
      scheduleRequestBody.donationFor = donationFor.trim();
    }

    const response = await api.publicRequest('/payments/create-donation-schedule', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(user && { Authorization: `Bearer ${localStorage.getItem('faithinsight_token')}` })
      },
      body: JSON.stringify(scheduleRequestBody)
    });

    if (response.success) {
      // Success! Navigate to confirmation page
      const donationData = {
        donationType: 'monthly',
        monthlyAmount: monthlyAmt,
        numberOfPayments: parseInt(payments),
        totalAmount: monthlyAmt * parseInt(payments),
        subscriptionScheduleId: response.scheduleId,
        subscriptionId: response.subscriptionId,
        status: response.status,
        user: {
          firstName,
          lastName,
          email,
          first_name: firstName,
          last_name: lastName
        }
      };

      // Navigate to confirmation page
      navigate('/donation/success', {
        state: { donationData }
      });
    } else {
      setError(response.message || response.error || 'Failed to create donation schedule. Please try again.');
      setLoading(false);
    }
  } catch (err) {
    setError(err.message || 'Failed to create donation. Please try again.');
    setLoading(false);
  }
};
